<template>
    <h6
        class="mb-5 whitespace-pre-line text-pretty px-2 text-[1rem] font-bold leading-[1.3] sm:px-5 lg:text-[1.125rem]"
    >
        <slot />
    </h6>
</template>
